//auth
export const POST_ERP_LOGIN = "/post-erp-login";
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const JWT_REGISTER = "/post-jwt-register";
export const POST_FAKE_REGISTER = "/post-fake-register";

export const USER_CHANGE_PASSWORD = "/user-change-password";

// profile & settings
export const GET_PROFILE_DETAILS = "/profile-details";
export const GET_USER_SETTINGS = "/user-settings";
export const UPDATE_ETTINGS = "/update-user-settings";
export const P2_CHANGE_IMAGE = "/p2-change-image";

// contacts
export const GET_CONTACTS = "/user-contacts";
export const INVITE_CONTACT = "/invite-contact";

// calls
export const GET_CALLS_LIST = "/calls-list";

// bookmarks
export const GET_BOOKMARKS_LIST = "/bookmarks-list";
export const DELETE_BOOKMARK = "/bookmarks-delete";
export const UPDATE_BOOKMARK = "/bookmarks-update";

// chats
export const GET_FAVOURITES = "/get-favourites";
export const GET_DIRECT_MESSAGES = "/get-direct-messages";
export const GET_CHANNELS = "/get-channles";
export const ADD_CONTACTS = "/add-contact";
export const CREATE_CHANNEL = "/create-channel";
export const GET_CHAT_USER_DETAILS = "/get-user-details";
export const GET_CHAT_USER_DETAILS_2S = "/chat-get-user-details";
export const GET_LAST_GROUP_CHAT_INFO_OF_MEMBER = "/get-last-group-chat-info-of-member";
export const DEL_USER_FROM_GROUP = "/del-user-from-group";
export const DEL_GROUP_FROM_USER = "/del-group-from-user";
export const ADD_USER_TO_GROUP = "/add-user-to-group";
export const GET_CHAT_USER_CONVERSATIONS = "/get-user-conversations";
export const SEND_MESSAGE = "/send-message";
export const RECEIVE_MESSAGE = "/receive-message";
export const READ_MESSAGE = "/read-message";
export const RECEIVE_MESSAGE_FROM_USER = "/receive-message-from-user";
export const DELETE_MESSAGE = "/delete-message";
export const FORWARD_MESSAGE = "/forward-message";
export const DELETE_USER_MESSAGES = "/delete-user-messages";
export const TOGGLE_FAVOURITE_CONTACT = "/toggle-favourite-contact";
export const GET_ARCHIVE_CONTACT = "/get-archive-contacts";
export const TOGGLE_ARCHIVE_CONTACT = "/toggle-archive-contact";
export const READ_CONVERSATION = "/read-conversation";
export const DELETE_IMAGE = "/user-delete-img";
export const APPLY_USER_TO_GROUP = "/apply-user-to-group";
export const FIND_MEMBER_TO_GROUP = "/find-member-to-group";
export const FIND_DCONNECT_WEB_USER = "/find-dconnect-web-user";
export const FIND_DCONNECT_CUS_FORMATCH = "/find-dconnect-cus-formatch";
export const FIND_ERP_SUP_FORMATCH = "/find-erp-sup-formatch";
export const VIEW_MSG_MEMBER = "/view-msg-member";
export const CREATE_NEW_CHAT_ROOM = "/create-new-chat-room";
export const CHANGE_GROUP_FULL_NAME = "/change-group-full-name";
export const SEARCH_CHAT = "/search-chat";
export const LOAD_QUICK_REPLY_CAT = "/load-quick-reply-cat";
export const QUICK_REPLY_SAVE = "/quick-reply-save";
export const QUICK_REPLY_LOAD_ALL = "/quick-reply-load-all";
export const SEND_QUICK_REPLY_TO_CHAT = "/send-quick-reply-to-chat";
export const SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE = "/search-chat-room-for-member-manage";
export const GET_LAST_SALE_CS_SYNC_TO_GROUP_DATE = "/get-last-sale-cs-sync-to-group-date";
export const SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL = "/search-chat-room-for-member-manage-user-ddl";
export const SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_APPLY = "/search-chat-room-for-member-manage-apply";
export const LOAD_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE = "/load-employee-who-are-2sonline-receiptance";
export const SAVE_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE = "/save-employee-who-are-2sonline-receiptance";
export const LOAD_EMPLOYEE_WHO_ARE_SUPPLIER_RECEIPTANCE = "/load-employee-who-are-supplier-receiptance";
export const SAVE_EMPLOYEE_WHO_ARE_SUPPLIER_RECEIPTANCE = "/save-employee-who-are-supplier-receiptance";
export const CHAT_GET_CONVERSION_IMG = "/chat-get-conversion-img";
export const UPLOAD_SLIP_PAYMENT = "/upload-slip-payment";
export const UPLOAD_SLIP_PAYMENT_VERIFY = "/upload-slip-payment-verify";
export const UPLOAD_SLIP_PAYMENT_LOAD = "/upload-slip-payment-load";
export const UPLOAD_SLIP_PAYMENT_DEL = "/upload-slip-payment-del";

// third
export const GET_CTN_ISSUE_ORDER_WAIT_DELIVERY_TINFO = "/get-ctn-issue-order-wait-delivery-tinfo";
export const GET_CONTENT_ORDER_GET_PENDING_DETAIL = "/get-content-order-get-pending-detail";

// groups
export const GET_CHANNEL_DETAILS = "/get-channel-details";



export const FIND_FOR_FILTER_CHAT_ROOM = "/find-for-filter-chat-room";

export const ERP_GET_CUSTOMER_TASK = "/erp-get-customer-task";
export const ERP_GET_PREV_TOP_NO_VOLUME = "/erp-get-prev-top-no-volume";
export const ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45 = "/erp-cate-size-not-sale-more-than-45";
export const ERP_CATE_INTEREST_NOT_SALE = "/erp-cate-interest-not-sale";
export const ERP_CATE_NOT_SALE_MORE_THAN_60 = "/erp-cate-not-sale-more-than-60";

export const ROTATE_IMAGE_FILE = "/rotate-image-file";
export const CHANGE_TO_CVIEW = "/change-to-cview";


export const CHECK_GROUP_INVITE_CODE = "/check-group-invite-code";

export const CREATE_NEW_CUSTOMER = "/create-new-customer";

export const LOAD_USER_FOR_EDIT = "/load-user-for-edit";
export const UPDATE_USER_FROM_EDIT = "/update-user-from-edit";

// general
export const UC_LOAD_USE_CONFIG = "/uc-load-user-config";
export const UC_UPDATE_USER_CONFIG = "/uc-update-user-config";
export const LOAD_EMP_I_FOLLOW = "/load-emp-i-follow";
export const TOGGLE_FOLLOWER = "/toggle-follower";
export const LOAD_DDL_VALUE_FOR_PERM = "/load-ddl-value-for-perm";
export const LOAD_PERM_CONFIG = "/load-perm-config";
export const SAVE_PERM_CONFIG = "/save-perm-config";
export const LOAD_EMPLOYEE_ORG = "/load-employee-org";
export const GET_EXTERNAL_LINK = "/get-external-link";
export const QUICK_REPLY_UPLOAD_FILE = "/quick-reply-upload-file";
export const QUICK_REPLY_LOAD = "/quick-reply-load";
export const QUICK_REPLY_DEL = "/quick-reply-del";
export const WRITE_LOG = "/write-log";
export const SAVE_PERM_CONFIG2 = "/save-perm-config2";
export const LOAD_PERM_CONFIG2 = "/load-perm-config2";
export const LOAD_PERM_CONFIG2_USER_BY_FILTER = "/load-perm-config2-user-by-filter";
export const DEL_PERM_CONFIG2 = "/del-perm-config2";
export const LOAD_PERM_CONFIG2_BY_PERM_NAME = "/load-perm-config2-by-perm-name";
export const SYNC_ERP_DATA_LOAD_STATUS = "/sync-erp-data-load-status";
export const SYNC_ERP_DATA_PERFORM = "/sync-erp-data-perform";
export const NOTIFICATION_GLOBAL_SAVE = "/notification-global-save";
export const NOTIFICATION_GLOBAL_SEARCH = "/notification-global-search";
export const NOTIFICATION_GLOBAL_DEL = "/notification-global-del";
export const NOTIFICATION_GLOBAL_LOAD_READSTAT = "/notification-global-load-readstat";
export const GET_DLL_VALUE_USER = "/get-dll-value-user";
export const GET_DLL_VALUE_TKPROJECT = "/get-dll-value-tkproject";
export const GET_DLL_VALUE_TASK_RECURANCE_FILTER = "/get-dll-value-task-recurance-filter";
export const WP_TAG_CAT_FOR_FILTER_2_COMPUTE_GET_STATUS = "/wp-tag-cat-for-filter-2-compute-get-status";
export const WP_TAG_CAT_FOR_FILTER_2_COMPUTE_FROM_QUEUE = "/wp-tag-cat-for-filter-2-compute-from-queue";

// workplace
export const WP_FIND_TAG = "/wp-find-tag";
export const WP_SAVE_POST = "/wp-save-post";
export const WP_SAVE_POST_TASK = "/wp-save-post-task";
export const WP_LOAD_POST_TITLE_V2 = "/wp-load-post-title";
export const WP_LOAD_POST_CONVER2 = "/wp-load-post-conver2";
// export const WP_LOAD_POST_INFO2 = "/wp-load-post-info2";
export const WP_LOAD_POST_INFO3 = "/wp-load-post-info3"
export const WP_SAVE_POST_INFO = "/wp-save-post-info";
export const WP_SAVE_POST_INFO_CHANGE_TASK_STATUS2 = "/wp-save-post-info-change-task-status2";
export const WP_SAVE_POST_INFO_REMOVE_TAG = "/wp-save-post-info-remove-tag";
export const WP_UPDATE_READ = "/wp-update-read";
export const WP_UPDATE_READ_MULTI = "/wp-update-read-multi";
export const WP_GET_ROLE_UNREAD_COUNT = "/wp-get-role-unread-count";
export const WP_LOAD_TAG_CAT = "/wp-load-tag-cat";
export const WP_LOAD_TAG_KEY = "/wp-load-tag-key";
export const WP_SAVE_TAG_CAT = "/wp-save-tag-cat";
export const WP_DEL_TAG_CAT = "/wp-del-tag-cat";
export const WP_LOAD_TAG_FOR_MEM = "/wp-load-tag-for-mem";
export const WP_LOAD_TAG_FOR_EDIT = "/wp-load-tag-for-edit";
export const WP_SAVE_TAG_KEY = "/wp-save-tag-key";
export const WP_DEL_TAG_KEY = "/wp-del-tag-key";
export const WP_LOAD_POST_INFO_MEMBER = "/wp-load-post-info-member";
export const WP_LOAD_TAG_INFO = "/wp-load-tag-info";
export const WP_LOAD_TAG_FOR_FILTER = "/wp-load-tag-for-filter";
export const WP_SEARCH_TAG_FROM_FILTER_PANE = "/wp-search-tag-from-filter-pane";
export const WP_LOAD_TAG_FOR_TOOLBOX = "/wp-load-tag-for-toolbox";
export const WP_LOAD_TAG_MEMBER_DTL = "/wp-load-tag-member-dtl";
export const WP_GET_POST_MEM_READ = "/wp-get-post-mem-read";
export const WP_TOGGLE_FLAG = "/wp-toggle-flag";
export const WP_SET_RESP_EMOJI = "/wp-set-resp-emoji";
export const WP_UPDATE_UNSEND = "/wp-update-unsend";
export const WP_DELETE_POST = "/wp-delete-post";
export const WP_CHANG_POST_STATUS = "/wp-chang-post-status";
export const WP_POST_SNOOZE_LOAD = "/wp-post-snooze-load";
export const WP_POST_SNOOZE_SAVE = "/wp-post-snooze-save";
export const WP_MARK_UNREAD = "/wp-mark-unread";
export const WP_LOAD_POST_IMAGE_FOR_GALLARY = "/wp-load-post-image-for-gallary";
export const WP_TAG_MASTER_MOVE = "/wp-tag-master-move";
export const WP_COMPUTE_MEM_IN_POST_BY_TAG_ID = "/wp-compute-mem-in-post-by-tag-id";
export const WP_LOAD_TASK_HIST = "/wp-load-task-hist";
export const WP_LOAD_TASK_DASH_V2 = "/wp-load-task-dash";
export const WP_LOAD_TASK_DASHBOARD_BY_DIV = "/wp-load-task-dashboard-by-div";
export const WP_LOAD_TASK_DASH_STATUSRANGE_V2 = "/wp-load-task-dash-statusrange";
export const WP_LOAD_TASK_DASH_TAGS_V2 = "/wp-load-task-dash-tags";
export const WP_LOAD_SUB_TASK = "/wp-load-sub-task";
export const WP_FIND_TAG_FOR_RECURANCE = "/wp-find-tag-for-recurance";
export const WP_SAVE_TASK_RECURRANCE = "/wp-save-task-recurrance";
export const WP_SAVE_TASK_RECURRANCE2 = "/wp-save-task-recurrance2";
export const WP_LOAD_TASK_RECURRANCE = "/wp-load-task-recurrance";
export const WP_SEARCH_TASK_RECURANCE = "/wp-search-task-recurance";
export const WP_DELETE_TASK_RECURANCE = "/wp-delete-task-recurance";
export const WP_GET_TASK_NEXT_DATE = "/wp-get-task-next-date";
export const WP_TK_LOAD_CHILD_TASK = "/wp-tk-load-child-task";
export const WP_TK_POST_FROM_RECURANCE = "/wp-tk-post-from-recurance";
export const WP_TK_CAN_VIEW_TASK = "/wp-tk-can-view-task";
export const WP_TK_COMPUTE_TASK_NAME = "/wp-tk-compute-task-name";
export const WP_GENERATE_TASK_RECURANCE_SCHEDULE = "/wp-generate-task-recurance-schedule";
export const UC_INIT_TAG_IN_RECURANCE_TASK_LOAD = "/uc-init-tag-in-recurance-task-load";
export const UC_INIT_TAG_IN_RECURANCE_TASK_SAVE = "/uc-init-tag-in-recurance-task-save";
export const WP_TAG_MASTER_CAT_LOAD = "/wp-tag-master-cat-load";
export const WP_GET_DLL_VALUE_EXTERNAL_USER_FILTER = "/wp-get-dll-value-external-user-filter";
export const WP_SEARCH_EXTERNAL_USER = "/wp-search-external-user";
export const SAVE_USER_EXTERNAL = "/save-user-external";
export const LOAD_USER_FOR_EDIT_2 = "/load-user-for-edit-2";
export const DELETE_USER_EXTERNAL = "/delete-user-external";
export const HOOK_PERFORM = "/hook-perform";
export const HOOK_SAVE = "/hook-save";
export const HOOK_SEARCH = "/hook-search";
export const HOOK_LOAD = "/hook-load";
export const HOOK_DELETE = "/hook-delete";
export const WP_TOGGLE_SUBSCRIBE_POST = "/wp-toggle-subscribe-post";
export const WP_LOAD_POST_WP_MODE = "/wp-load-post-wp-mode";
export const WP_TAG_CAT_FOR_FILTER2ALLOW_REPORTBYEMP = "/wp-tag-cat-for-filter2allow-reportbyemp";
export const WP_UPDATE_POST_ICON = "/wp-update-post-icon";